export const tokenStorage = {
  set: (token: string) => {
    sessionStorage.setItem("accessToken", token);
  },
  get: () => sessionStorage.getItem("accessToken"),
  clear: () => {
    sessionStorage.removeItem("accessToken");
  },
};
